<template>
	<section class="library-album-container">
	<img :src="album.cover.sizes.large" v-if='loaded' alt="" class="library-album-container-blur-bg">
		<div class="container">
		<div class="img-hide-alert">
			⚠️ Альбом не поддерживает режим отключения изображений на странице.
		</div>
			<div class="library-album-content">
				<div class="album-about" v-if='loaded'>
					<div class="row">
						<div class="col-12 col-md-6 col-lg-4">
							<div class="album-about-cover">
								<img :src="album.cover.sizes.large" width="100%" height="auto">
							</div>
						</div>	
						<div class="col-12 col-md-6 col-lg-8">
							<div class="album-about-text">
								<h1 v-html="album.title"></h1>
								<p v-html="album.subtitle"></p>
							</div>
						</div>
					</div>
				</div>
				<div class="album-about" v-if='!loaded'>
					<div class="row">
						<div class="col-12 col-md-6 col-lg-4">
							<div class="album-about-cover">
							</div>
						</div>	
						<div class="col-12 col-md-6 col-lg-8">
							<div class="album-about-text">
							</div>
						</div>
					</div>
				</div>
				<!--<div class="blurred-background" :style="{'background-image': album.cover.sizes['blurred-thumb']}"></div>-->
				<div v-if="loaded">
					<vue-picture-swipe class="library-album-feed" :items="album.photos" :options="pswpOptions"></vue-picture-swipe>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import VuePictureSwipe from 'vue-picture-swipe';	
import store from "../../store/";

export default {
	name: "LibraryAlbum",
	store,
	data() {
      return {
			pswpOptions: {
				shareEl: false,
				preload: [1, 2],
			}
    	}
	},
	created() {
		this.$store.dispatch("LibraryAlbum/fetchAlbum", {
			albumId: this.$route.params.albumId
		});
	},
	computed: {
		loaded() {
			return this.$store.state["LibraryAlbum"].loaded;
		},
		album() {
			return this.$store.state["LibraryAlbum"].album;
		}
	},
};
</script>



// WEBPACK FOOTER //
// src/components/LibraryAlbum/index.vue